/**
 * User-facing copy for LMSR sell failures (edge function / PostgREST).
 */

export function friendlyLmsrSellError(err: unknown): string {
  const appCode =
    err &&
    typeof err === 'object' &&
    'error_code' in err &&
    typeof (err as { error_code: unknown }).error_code === 'string'
      ? (err as { error_code: string }).error_code
      : '';
  if (appCode === 'LMSR_SELL_LOCK_CONTENTION') {
    return 'Another action may have locked your position momentarily. Please try again.';
  }
  const obj = (err ?? {}) as { message?: unknown; code?: unknown };
  const raw = err instanceof Error ? err.message : typeof obj.message === 'string' ? obj.message : '';
  const code = typeof obj.code === 'string' ? obj.code : '';
  if (/insufficient\s*shares|not enough shares|shares_owned/i.test(raw)) {
    return 'You do not have enough shares to sell that amount.';
  }
  if (/max[_\s]?cost|slippage|price moved/i.test(raw)) {
    return 'The price changed while you were selling. Please try again.';
  }
  if (/lock|contention|LMSR_SELL_LOCK_CONTENTION/i.test(raw)) {
    return 'Another action may have locked your position momentarily. Please try again.';
  }
  if (/not\s*(open|active)|market.*closed|resolved/i.test(raw)) {
    return 'This market is no longer open for selling.';
  }
  if (/auth/i.test(raw) || code === '401') {
    return 'You are signed out. Please log in and try again.';
  }
  if (/network|fetch|timeout/i.test(raw)) {
    return 'We could not reach the server. Check your connection and try again.';
  }
  return 'Something went wrong while selling your shares. Please try again.';
}
